import React, {useEffect, useState} from "react";
import {Box, ButtonLink, Heading, Stack, Text, View} from "@unibuddy/patron";
import {useUniversityContext} from "../../../../providers/UniversityProvider";
import {useBooleanFeatureFlag} from "ub-feature-flagging-react";
import {SHOW_STANDALONE_CONTEXT} from "../../../../utils/featureFlags";

export function StandaloneChatWrapper({children}: Readonly<{children: React.ReactNode}>) {
    const shouldShowStandaloneContext = useBooleanFeatureFlag(
        SHOW_STANDALONE_CONTEXT.key,
        SHOW_STANDALONE_CONTEXT.defaultValue,
    );

    const [shouldHideWrapper, setShouldHideWrapper] = useState<boolean>(window.innerWidth < 700);
    const {universityName} = useUniversityContext();

    useEffect(() => {
        const handleResize = () => {
            setShouldHideWrapper(window.innerWidth < 700);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    if (window.self !== window.top || shouldHideWrapper) return children;

    return (
        <View
            height="100%"
            maxW="100%"
            justifyContent="center"
            alignItems="center"
            bgColor="white"
            padding="small"
        >
            <Stack space={["small", "large"]}>
                <Heading level="1" align="center">
                    Unibuddy Assistant
                </Heading>
                <Box display="flex" flexDirection="row" gap="large">
                    <View
                        flexShrink={0}
                        minW="320px"
                        maxW="450px"
                        minH="85vh"
                        maxH="85vh"
                        borderWidth={1}
                        borderColor="grey150"
                        borderRadius="small"
                        overflow="hidden"
                    >
                        {children}
                    </View>
                    {shouldShowStandaloneContext && (
                        <View maxW="450px" alignItems="flex-start">
                            <Stack space="medium-large">
                                <Box
                                    bgColor="grey50"
                                    borderRadius="small"
                                    padding="small-medium"
                                    borderWidth={1}
                                    borderColor="grey100"
                                >
                                    <Stack space="small-medium">
                                        <Text weight="bold">Information</Text>
                                        <Text>
                                            {`This is an experimental feature - ask the assistant any
                                        questions you have about ${
                                            universityName || "the institution"
                                        }, and let us know
                                        what you think of the responses. The assistant can make
                                        mistakes, so consider checking important information.`}
                                        </Text>
                                    </Stack>
                                </Box>
                                <ButtonLink
                                    external
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    color="primary"
                                    block
                                    to="https://tally.so/r/wQ7Dzg"
                                >
                                    {"Give feedback >"}
                                </ButtonLink>
                            </Stack>
                        </View>
                    )}
                </Box>
            </Stack>
        </View>
    );
}
